const pasaFotos = document.querySelector('.pasafotos');
const openPasaFotos = document.querySelector('.mainImage');
const closePasaFotos = document.querySelector('.pasafotos button');
const pasafotosWrapper = document.querySelector('.pasafotos__wrapper');

if(pasaFotos) {
  openPasaFotos.addEventListener("click", () => {
    pasaFotos.showModal();
  });
  pasaFotos.addEventListener("click", (event) => {
    if(event.target === pasaFotos) {
      pasaFotos.close();
    }
  })
  closePasaFotos.addEventListener("click", () => {
    pasaFotos.close();
  });
}